import styled from 'styled-components';

export const Title = styled.div`
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.grey900};
`;

export const Description = styled.div`
  color: ${props => props.theme.colors.grey700};
  font-size: ${props => props.theme.fontSizes[1]};
`;
